module.exports = __webpack_public_path__ + "static/media/forest.0c1ea493.jpg";